import React from 'react';
import { FieldFeedbackLabel } from './FieldFeedbackLabel';

const getFieldCSSClasses = (touched, errors, extraClassName = '') => {
  const classes = ['form-control'];
  if (errors) classes.push('is-invalid');
  if (touched && !errors) classes.push('is-valid');
  if (extraClassName) classes.push(extraClassName);
  return classes.join(' ');
};

export function Input({
  labelClassName,
  field,
  form: { touched, errors },
  form,
  label,
  withFeedbackLabel = true,
  customFeedbackLabel,
  type = 'text',
  rows,
  className,
  customError,
  ...props
}) {
  const hasError = customError || errors[field.name];
  const isTouched = touched[field.name];
  const resolvedValue = props.value ?? field.value;
  const safeValue = resolvedValue === null || resolvedValue === undefined ? '' : resolvedValue;

  return (
    <>
      {label && <label className={`${labelClassName || ''}`}>{label}</label>}
      {!rows && (
        <input
          type={type}
          className={getFieldCSSClasses(isTouched, hasError, className)}
          {...field}
          {...props}
          value={safeValue}
        />
      )}
      {rows && (
        <textarea
          rows={rows}
          type={type}
          className={getFieldCSSClasses(isTouched, hasError)}
          {...field}
          {...props}
          value={safeValue}
        />
      )}
      {withFeedbackLabel && !customError && (
        <FieldFeedbackLabel
          error={hasError}
          touched={isTouched}
          label={label}
          type={type}
          customFeedbackLabel={customFeedbackLabel}
        />
      )}
    </>
  );
}
